import { FC } from 'react'
import CustomPopup from '../../UI/Popup'
import CustomButton from '../../UI/Buttons/CustomButton'
import Checkbox from '../../UI/Inputs/Checkbox'

import { useDispatch, useSelector } from '../../../store'
import {
  toggleChoosePostTypeAction,
  toggleIsAddingPostAction,
  openSchedulePostModal
} from '../../../store/application/slice'

import './ModalPostType.scss'
import { setPostTypeAction } from '../../../store/managePost/slice'
import { SOCIAL_NETWORK, POST_TYPE } from '../../../models/post'
import { SCHEDULE_ACTION_TYPES } from '../../../store/application/types'

const ModalPostType: FC<any> = () => {
  const dispatch = useDispatch()
  const { isOpenPostType, postType, selectedPostType, selectedSocials } = useSelector((state) => ({
    isOpenPostType: state.app.isOpenPostType,
    postType: state.managePost.availablePostTypes,
    selectedPostType: state.managePost.selectedPostType,
    selectedSocials: state.managePost.selectedSocials
  }))

  const close = () => {
    dispatch(toggleChoosePostTypeAction())
  }
  const startSchedulePost = () => {
    dispatch(openSchedulePostModal(SCHEDULE_ACTION_TYPES.SHEDULE_TO_ROUTE))
    close()
  }
  const backToChooseSocials = () => {
    dispatch(toggleIsAddingPostAction())
    close()
  }

  const isPostTypeDisabled = (postType:any) => {
    //Condition added to disable multiple images, gif if twitter is among the social media selected selected
    if (selectedSocials.includes(SOCIAL_NETWORK.TWITTER_SOCIAL)) {
      if (postType == POST_TYPE.POST_TYPE_MULTI_PHOTO || postType ==POST_TYPE.POST_TYPE_ANIMATED_GIF) {
        return true;
      }
    }
  }

  return (
    <CustomPopup
      open={isOpenPostType}
      buttonClose={close}
      closeOnDocumentClick={false}
      className='type-new-post'
    >
      <div className='type-new-post__wrapper'>
        <div className='type-new-post__wrapper__title'>What do you want to create?</div>
        <div className='type-new-post__wrapper__chooise'>
          {postType.map((type: POST_TYPE) => {
            const isChecked = selectedPostType === type
            const displayType = type.replace('_', ' ').replace('-', ' ').replace('gif','GIF');
            return (
              <div
                key={`post-type-${type}`}
                className={`type-new-post__wrapper__chooise__original post-type ${
                  isChecked && 'active'
                }`}
              >
                <Checkbox
                  type='checkbox'
                  checked={isChecked}
                  // disabled={isPostTypeDisabled(type)}
                  label={displayType.charAt(0).toUpperCase() + displayType.slice(1)}
                  onChange={() => dispatch(setPostTypeAction(type))}
                />
              </div>
            )
          })}
        </div>
        <div className='type-new-post__wrapper__actions'>
          <CustomButton onClick={backToChooseSocials} button='secondary'>
            Back
          </CustomButton>
          <CustomButton disabled={false} onClick={startSchedulePost} button='primary'>
            Next
          </CustomButton>
        </div>
      </div>
    </CustomPopup>
  )
}

export default ModalPostType
